import { useRef, useState } from "react";
import PaintServiceClient from "../services/paint-service.client";
import { Paint } from "../types/Paint";

interface ViewProps {
  selectedPaint: Paint;
  handleClose: () => void;
  onError: (message: string) => void;
}

const ViewPaint = (props: ViewProps) => {
  const paintService = useRef(new PaintServiceClient());
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleApprove = () => {
    if (window.confirm("Are you sure you want to approve this paint?")) {
      console.log("Approved:", props.selectedPaint);

      paintService.current.approve(props.selectedPaint!.id)
        .then(() => props.handleClose())
        .catch((e: any) => props.onError(e.Message));
    }
  };

  const handleReject = () => {
    if (window.confirm("Are you sure you want to reject this paint?")) {
      console.log("Rejected:", props.selectedPaint);

      paintService.current.reject(props.selectedPaint!.id)
        .then(() => props.handleClose())
        .catch((e: any) => props.onError(e.Message));
    }
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % props.selectedPaint.files.filter(file => !file.uri.endsWith(".mas")).length);
  };

  const handlePreviousImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + props.selectedPaint.files.filter(file => !file.uri.endsWith(".mas")).length) % props.selectedPaint.files.filter(file => !file.uri.endsWith(".mas")).length);
  };

  const handleOutsideClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if ((e.target as HTMLElement).id === "modal-container") {
      props.handleClose();
    }
  };

  return (
    <div
      id="modal-container"
      onClick={handleOutsideClick}
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "100%",
        height: "80%",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "90%",
          height: "70%",
        }}
      >
        <button
          onClick={handlePreviousImage}
          style={{
            position: "absolute",
            left: "10px",
            fontSize: "5rem",
            color: "white",
            border: "none",
            cursor: "pointer",
            background: "none",
          }}
        >
          ◀
        </button>

        <img
          src={props.selectedPaint.files.filter(file => !file.uri.endsWith(".mas"))[currentImageIndex].uri}
          alt="Selected Paint"
          style={{ maxWidth: "90%", maxHeight: "100%" }}
        />

        <button
          onClick={handleNextImage}
          style={{
            position: "absolute",
            right: "10px",
            fontSize: "5rem",
            color: "white",
            border: "none",
            cursor: "pointer",
            background: "none",
          }}
        >
          ▶
        </button>
      </div>

      <div
        style={{
          position: "absolute",
          bottom: "20px",
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <button
          onClick={handleApprove}
          style={{
            marginRight: "10px",
            padding: "10px 20px",
            backgroundColor: "green",
            color: "white",
            border: "none",
            cursor: "pointer",
          }}
        >
          Approve
        </button>
        <button
          onClick={handleReject}
          style={{
            marginRight: "10px",
            padding: "10px 20px",
            backgroundColor: "red",
            color: "white",
            border: "none",
            cursor: "pointer",
          }}
        >
          Reject
        </button>
        <button
          onClick={() => props.handleClose()}
          style={{
            padding: "10px 20px",
            backgroundColor: "black",
            color: "white",
            border: "none",
            cursor: "pointer",
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ViewPaint;
